import { ApiGateWay } from './../../../ApiGateWay/ApiGateWay';
import { Config } from './../../../config/config';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

export const RETAIL_TRAINING_GLOBAL = async (
  url,
  userId,
  month,
  year,
  type
) => {
  const fetchedData = await ApiGateWay.Post(config['api'] + url, {
    userId: userId,
    month: month,
    year: year,
  })
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let colorCodes = [];
      let proxyjson = [];
      let stores = [];
      let storeID = [];
      let obj;
      response.ratailDashboardInfo.map((name, val) => {
        storeID.push(name.storeId);
        stores.push(name.storeName);

        if (val == 0) {
          obj = name;
        }
        let color = [];
        name.inductionValue == 100
        ? color.push(1)
        : name.inductionValue < 95
        ? color.push(2)
        : color.push(12);
          name.fatFrtValue >= 80
          ? color.push(1)
          : name.fatFrtValue < 70
          ? color.push(2)
          : color.push(12)
          name.flowsValue >= 80
          ? color.push(1)
          : name.flowsValue < 70
          ? color.push(2)
          : color.push(12);
        name.dmTrainingPercentage.toString() ==
        obj.dmTrainingPercentage.toString()
          ? color.push(1)
          : color.push(0);
        /*  name.dmValidationPercentage.toString() ==
        obj.dmValidationPercentage.toString()
          ? color.push(1)
          : color.push(2); */
        name.validationValue == '100'
          ? color.push(1)
          : name.validationValue < '90'
          ? color.push(2)
          : color.push(12);
        name.dmRevalidationPercentage.toString() ==
        obj.dmRevalidationPercentage.toString()
          ? color.push(0)
          : color.push(0);
        name.somPercentage.toString() == obj.somPercentage.toString()
          ? color.push(1)
          : color.push(0);
        name.dmDevalidationPercentage.toString() == obj.dmDevalidationPercentage.toString()
          ? color.push(0)
          : color.push(0);

        if (val == 0) {
          colorCodes.push([0, 0, 0, 0, 0, 0, 0, 0]);
        } else colorCodes.push(color);

        body.push([
          name.inductionPercentage,
          name.fatFrtPercentage,
          name.flowsPercentage,
          name.dmTrainingPercentage,
          name.dmValidationPercentage,
          name.dmRevalidationPercentage,
          name.somPercentage,
          name.dmDevalidationPercentage,
        ]);
      });
      return (proxyjson = {
        type: 'Training',
        thead: [
          'Store Name',
          'Induction',
          'FAT and FRT',
          'Flows Training',
          'DM Training',
          'DM Validation',
          'DM Revalidation',
          'SOM Training',
          'DM Devalidation',
        ],
        tbody: body,
        columns: [
          'Store Name',
          'Induction',
          'FAT and FRT',
          'Flows Training',
          'DM Training',
          'DM Validation',
          'DM Revalidation',
          'SOM Training',
          'DM Devalidation',
        ],
        colorCodes: colorCodes,
        storeId: storeID,
        stores: stores,
      });
    });
  return fetchedData;
};

export const RETAIL_TRAINING_STATUS = async (url, month, year, storeId) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] +
      url +
      '?month=' +
      month +
      '&year=' +
      year +
      '&storeId=' +
      storeId
  )
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();

        return (window.location = '/');
      }
      let body = [];
      let colorCodes = [];
      let proxyjson = [];
      let stores = [];
      let storeID = [];
      let obj;
      response.retailStatus.map((name, val) => {
        storeID.push(name.storeId);
        stores.push(name.storeName);

        body.push([
          name.employeeName,
          name.inductionStatus,
          name.fatFrtStatus,
          name.flowsStatus,
          name.dmTrainingStatus,
          name.dmValidationStatus,
          name.dmRevalidationStatus,
          name.somStatus,
          name.dmDevalidationStatus,
        ]);
      });
      return (proxyjson = {
        type: 'Training',
        thead: [
          'Employee Name',
          'Induction',
          'FAT and FRT',
          'Flows Training',
          'DM Training',
          'DM Validation',
          'DM Revalidation',
          'SOM Training',
          'DM Devalidation',
        ],
        tbody: body,
        columns: [
          'Employee Name',
          'Induction',
          'FAT and FRT',
          'Flows Training',
          'DM Training',
          'DM Validation',
          'DM Revalidation',
          'SOM Training',
          'DM Devalidation',
        ],
        colorCodes: colorCodes,
        storeId: storeID,
        stores: stores,
      });
    });
  return fetchedData;
};
